import type { Appointment, TimeBlock } from '../api/client'
import { minutesToTime } from '../catalog/format'
import { clientName } from './names'

// conflictMessage names what a save would overlap: a client's appointment
// first ("Overlaps Holly Burns at 11:30"), then a block she made ("Overlaps
// your block at 14:30", or by its label), and only when nothing else is in the
// way, the blocked time after a treatment — then how many more (review
// 2026-10-14: a real double booking must never hide behind blocked time).
// With proposed given, a booking whose treatment has ended by the new start
// (or that is on an earlier day) is in the way only through its blocked time.
export function conflictMessage(
  conflicts: Appointment[],
  proposed?: { date: string; start_minute: number },
  blocks: TimeBlock[] = [],
): string {
  if (conflicts.length === 0 && blocks.length === 0) {
    return 'This overlaps another appointment.'
  }
  const blockOnly = (c: Appointment) =>
    proposed !== undefined && (proposed.date > c.date || (proposed.date === c.date && proposed.start_minute >= c.end_minute))
  const ordered = [...conflicts.filter((c) => !blockOnly(c)), ...conflicts.filter(blockOnly)]
  const [first] = ordered
  const more = ordered.length + blocks.length > 1 ? `, and ${ordered.length + blocks.length - 1} more` : ''
  if (first && !blockOnly(first)) {
    return `Overlaps ${clientName(first.client)} at ${minutesToTime(first.start_minute)}${more}`
  }
  if (blocks.length > 0) {
    const [block] = [...blocks].sort((a, b) => a.start_minute - b.start_minute)
    return `Overlaps ${block.label ?? 'your block'} at ${minutesToTime(block.start_minute)}${more}`
  }
  return `Overlaps the blocked time after ${clientName(first.client)}’s ${minutesToTime(first.start_minute)}${more}`
}

export function bookedMessage(a: Appointment): string {
  return a.outside_hours ? 'Booked — outside your working hours' : 'Booked'
}
